import { SnackbarComponent } from '../shared/components/snackbar/snackbar.component';
import { MatSnackBar } from '@angular/material/snack-bar';
import { Injectable } from '@angular/core';
import { MatDialog, MatDialogConfig, type MatDialogRef } from '@angular/material/dialog';
import { ModalComponent } from '@shared/components/modal/modal.component';
import { ConfirmationsModalComponent } from '@shared/components/confirmations-modal/confirmations-modal.component';

type ISnackbarType = 'success' | 'warn' | 'info' | 'advice';

@Injectable({
  providedIn: 'root'
})
export class SnackbarService {

  public style: string[];

  constructor(
    private snackBar: MatSnackBar,
    private dialog: MatDialog
  ) { }

  public openSnackbar(text: string, type: ISnackbarType, icon = false, dismiss = false, confirmMessage = 'CLUB.understood', textCenter = true, iconCenter = true): any {
    this.style = [];
    switch (type) {
      case 'success':
        this.style.push('as-snackbar-success');
        break;
      case 'warn':
        this.style.push('as-snackbar-warn');
        break;
      case 'info':
        this.style.push('as-snackbar-info');
        break;
      case 'advice':
        this.style.push('as-snackbar-advice');
        break;
    }


    if (icon) {
      this.style.push('as-snackbar-icon');
      if (iconCenter) {
        this.style.push('as-snackbar-icon-center');
      } else {
        this.style.push('as-snackbar-icon-start');
      }
    }
    if (textCenter) {
      this.style.push('as-snackbar-text-center');
    } else {
      this.style.push('as-snackbar-text-start');

    }

    return this.snackBar.openFromComponent(SnackbarComponent, {
      data: {
        text,
        icon,
        dismiss,
        textCenter,
        confirmMessage
      },
      duration: 3000,
      panelClass: this.style,
      verticalPosition: 'bottom',
      horizontalPosition: 'center'
    });

  }

  public openDialog(data: object, config: MatDialogConfig): MatDialogRef<undefined | any> {
    return this.dialog.open(ModalComponent, {
      data,
      ...config
    });
  }

  public openResultsModal(data: object, config: MatDialogConfig): MatDialogRef<undefined | any> {
    return this.dialog.open(ConfirmationsModalComponent, {
      data,
      ...config
    });
  }
}
